import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { cardPad } from '../../lib/ui';

export default function InsCompare() {
  const { state, go, set, L } = useApp();

  const inscTabDefs = [
    { key: 'c1', label: 'Class 1' },
    { key: 'c2', label: 'Class 2 & 3' },
    { key: 'c3', label: 'All Classes' },
  ] as const;
  const inscTabs = inscTabDefs.map((tb) => {
    const active = state.inscTab === tb.key;
    return {
      key: tb.key,
      label: L(tb.label, tb.label === 'Class 1' ? 'ชั้น 1' : tb.label === 'Class 2 & 3' ? 'ชั้น 2 และ 3' : 'ทุกชั้น'),
      onClick: () => set({ inscTab: tb.key }),
      border: active ? 'var(--color-primary)' : 'var(--color-border)',
      bg: active ? 'var(--color-purple-100)' : 'var(--color-white)',
      color: active ? 'var(--color-primary-hover)' : 'var(--color-fg-2)',
    };
  });

  const insRowDefs = [
    { f: 'Premium (USD)', a: '$4,620,000', b: '$4,790,000', c: '$4,960,000', low: 'a', font: 'var(--font-mono)' },
    { f: 'Excess / Deductible', a: '$20,000', b: '$15,000', c: '$25,000', low: 'b', font: 'var(--font-mono)' },
    { f: 'Coverage Limit', a: '$5,000,000', b: '$5,000,000', c: '$4,500,000', low: '', font: 'var(--font-mono)' },
    { f: 'Roadside Assistance', a: 'Included', b: 'Included', c: 'Add-on', low: '', font: 'var(--font-sans)' },
    { f: 'AI Score', a: '94', b: '87', c: '79', low: 'a', font: 'var(--font-mono)' },
  ];
  const featTh: Record<string, string> = {
    'Premium (USD)': 'เบี้ยประกัน (USD)',
    'Excess / Deductible': 'ค่าเสียหายส่วนแรก',
    'Coverage Limit': 'วงเงินคุ้มครอง',
    'Roadside Assistance': 'ช่วยเหลือฉุกเฉินบนถนน',
    'AI Score': 'คะแนน AI',
  };
  const tv = (v: string) => (v === 'Included' ? L('Included', 'รวมอยู่แล้ว') : v === 'Add-on' ? L('Add-on', 'เสริม') : v);
  const insMatrix = insRowDefs.map((r) => ({
    f: L(r.f, featTh[r.f] ?? r.f),
    font: r.font,
    a: tv(r.a),
    b: tv(r.b),
    c: tv(r.c),
    aLowest: r.low === 'a',
    aBg: r.low === 'a' ? 'var(--color-success-bg)' : 'transparent',
    aColor: r.low === 'a' ? 'var(--color-success)' : 'var(--color-fg-1)',
  }));

  return (
    <>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {inscTabs.map((t2) => (
          <button key={t2.key} onClick={t2.onClick} style={{ padding: '8px 18px', border: `1px solid ${t2.border}`, borderRadius: 'var(--radius-pill)', fontSize: 13, fontWeight: 600, background: t2.bg, color: t2.color }}>{t2.label}</button>
        ))}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', background: 'var(--color-success-bg)', border: '1px solid var(--color-success)', borderRadius: 'var(--radius-md)', marginBottom: 16, fontSize: 13, color: 'var(--color-success)' }}>
        <Icon name="sparkles" />
        <span style={{ color: 'var(--color-fg-1)' }}><b>{L('AI recommends Insurer A', 'AI แนะนำผู้รับประกันภัย A')}</b>{L(' at ', ' ที่ ')}$4,620,000{L('. Insurer identity is revealed after the award is confirmed.', '. ตัวตนของผู้รับประกันภัยจะเปิดเผยหลังยืนยันการมอบรางวัลแล้ว')}</span>
      </div>
      <div style={cardPad(0, 'auto')}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 760 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontSize: 11, fontWeight: 700, color: 'var(--color-fg-3)' }}>{L('Feature', 'คุณสมบัติ')}</th>
              <th style={{ textAlign: 'center', padding: '12px 16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontWeight: 700 }}><Icon name="eye-off" style={{ fontSize: 13, color: 'var(--color-fg-3)' }} />{L('Insurer A', 'ผู้รับประกันภัย A')}</span>
                  <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 999, background: 'var(--color-success-bg)', color: 'var(--color-success)' }}>{L('AI PICK', 'AI เลือก')}</span>
                </div>
              </th>
              <th style={{ textAlign: 'center', padding: '12px 16px' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontWeight: 700 }}><Icon name="eye-off" style={{ fontSize: 13, color: 'var(--color-fg-3)' }} />{L('Insurer B', 'ผู้รับประกันภัย B')}</span>
              </th>
              <th style={{ textAlign: 'center', padding: '12px 16px' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontWeight: 700 }}><Icon name="eye-off" style={{ fontSize: 13, color: 'var(--color-fg-3)' }} />{L('Insurer C', 'ผู้รับประกันภัย C')}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {insMatrix.map((r, i) => (
              <tr key={i} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '11px 16px', fontWeight: 600, color: 'var(--color-fg-2)' }}>{r.f}</td>
                <td style={{ padding: '11px 16px', textAlign: 'center', fontFamily: r.font, fontWeight: 600, background: r.aBg, color: r.aColor }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, justifyContent: 'center' }}>
                    {r.aLowest && <span style={{ fontSize: 10 }}>▼ {L('Lowest', 'ต่ำสุด')}</span>}
                    {r.a}
                  </span>
                </td>
                <td style={{ padding: '11px 16px', textAlign: 'center', fontFamily: r.font }}>{r.b}</td>
                <td style={{ padding: '11px 16px', textAlign: 'center', fontFamily: r.font }}>{r.c}</td>
              </tr>
            ))}
            <tr>
              <td style={{ padding: '14px 16px' }}></td>
              <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                <button onClick={() => go('award')} className="hv-primary" style={{ padding: '8px 18px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-sm)', fontWeight: 600, fontSize: 13 }}>{L('Select', 'เลือก')}</button>
              </td>
              <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                <button onClick={() => go('award')} style={{ padding: '8px 18px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontWeight: 600, fontSize: 13, background: 'var(--color-white)' }}>{L('Select', 'เลือก')}</button>
              </td>
              <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                <button onClick={() => go('award')} style={{ padding: '8px 18px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', fontWeight: 600, fontSize: 13, background: 'var(--color-white)' }}>{L('Select', 'เลือก')}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ fontSize: 12, color: 'var(--color-fg-3)', marginTop: 12 }}>{L('AI weighting: Premium 40% · Coverage 25% · Claim speed 15% · Performance 12% · Commission 8%.', 'น้ำหนัก AI: เบี้ยประกัน 40% · ความคุ้มครอง 25% · ความเร็วเคลม 15% · ผลงาน 12% · ค่าคอมมิชชัน 8%')}</div>
    </>
  );
}
